import React, { useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchBar } from '@uncinc/react-searchkit';
import type { SearchBarProps } from '@uncinc/react-searchkit/dist/components/SearchBar';
import type { SearchBarButtonProps } from '@uncinc/react-searchkit/dist/components/SearchBar/Base';
import type { SearchResetButtonProps } from '@uncinc/react-searchkit/dist/components/Reset';

import './style.scss';

const SearchBarButton = (buttonProps: SearchBarButtonProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'components.search_forum.search_bar' });

  return (
    <button
      {...buttonProps}
      type="submit"
      className="SearchForum__SearchBar__submit"
    >
      {t('search')}
    </button>
  );
};

const ResetButton = (buttonProps: SearchResetButtonProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'components.search_forum.search_bar' });

  return (
    <button
      {...buttonProps}
      type="button"
      className="SearchForum__SearchBar__reset"
      aria-label={t('reset')}
    >
      <i className="icon icon-cross icon-variant-2" />
    </button>
  );
};

const SearchForumSearchBar: React.FC<SearchBarProps> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'components.search_forum.search_bar' });

  const searchBarRef = useRef<HTMLInputElement>(null);

  const classNames = c('SearchForum__SearchBar', className);

  return (
    <SearchBar
      {...restProps}
      ref={searchBarRef}
      className={classNames}
      title={t('title')}
      button={SearchBarButton}
      placeholder={t('placeholder')}
      autoFocus
      showReset
      resetProps={{ button: ResetButton }}
    />
  );
};

export default SearchForumSearchBar;
